"use strict";
/**
 * QVET Staff Helpers
 *
 * Utility functions for normalizing QVET staff names for alias matching.
 *
 * QVET exports strip accents inconsistently (e.g., AVENDAÑO → AVENDANO or AVENDAO).
 * This normalizer strips all diacritics so lookups work regardless of source encoding.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeQvetName = normalizeQvetName;
/**
 * Normalize a QVET staff name for alias matching.
 *
 * - Uppercase
 * - Strip diacritics (NFD decompose + remove combining marks): ñ→N, é→E, etc.
 * - Collapse multiple whitespace to single space
 * - Trim leading/trailing whitespace
 *
 * @param name - Raw name from QVET export or user input
 * @returns Normalized name, or empty string for null/undefined/empty
 */
function normalizeQvetName(name) {
    if (!name)
        return '';
    return name
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase()
        .replace(/\s+/g, ' ')
        .trim();
}
